import styled from 'styled-components';
import color from '../../../config/colors.json';

export const Title = styled.div`
	background-color: ${color.greyMidias};
	padding: 14px 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	> [role="img"] {
		margin-right: 15px;
	}
	> em {
		font-style: normal;
		font-size: 14px;
		line-height: 21px;	
		color: ${color.light};
		font-family: 'Poppins', sans-serif;
		margin: 0;
	}
`;

export const Content = styled.div`
	padding: 30px;
`;
